// extracted by mini-css-extract-plugin
export default {"modal":"_9cf67762","dragArea":"_efb2804e"};